module.exports = __webpack_public_path__ + "static/media/thumbnail-termelouzem_iroda_kialakitas_2.1900bd99.jpg";